import * as requestFromServer from './crud'
import { callTypes, structureSlice } from './slice'
import api from '../../../services/api';
import apiMatriz from '../../../services/apiMatriz';
const { actions } = structureSlice;

const fetchStructure = () => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer
        .getAll().then((response) => {
            const { _count, value } = response.data
            dispatch(actions.structureFetched({ totalCount: _count || value.length, entities: value }))
        }).catch(error => {
            error.clientMessage = "Não é possível encontrar as estruturas";
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        })
}

export async function apiGETFactoryStructures(FactoryId) {
    const response = (await api.get('/structure/odata?$expand=father($select=name)&$select=id,name&$filter=factoryId+eq+' + FactoryId)).data
   
    return response
}

export async function apiGETMatrices(FactoryId) {
    const response = (await apiMatriz.get('/structure/odata?$expand=MatrixUsers($select=id;$expand=User($select=sap))&$select=id,name&$filter=factoryId+eq+' + FactoryId)).data

    return response.value
}

export { fetchStructure }